import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Div, Text } from '@pinpoint/design-kit';

import BaseDialog from './base';
/* eslint-disable react/prop-types */

export function DeleteSegmentDialog({ isOpen, actions, type = 'segment', dependentResources }) {
  const deleteMsg = `Are you sure you want to delete the ${type === 'segment' ? 'dataset' : 'cluster'}?`;
  const unableToDeleteMsg =
    'This dataset cannot be deleted. The following models are dependent on it. Please delete them first:';
  const buttons = [];
  if (dependentResources.length === 0)
    buttons.push({
      text: 'YES',
      textSize: 'body',
      close: true,
    });
  return (
    <BaseDialog
      isOpen={isOpen}
      actions={actions}
      title={{
        text: `Delete ${type === 'segment' ? 'Dataset' : 'Cluster'}`,
        backgroundColor: 'brand300',
        color: 'white',
        textSize: 'title',
        icon: <Icon name="AlertSolid" color="white" viewBox="0 0 24 24" size="3.125rem" m={{ r: '1rem' }} />,
      }}
      items={{
        content: [
          <Text textSize="paragraph" textWeight="500" textColor="shade66">
            {dependentResources.length > 0 ? (
              <>
                {unableToDeleteMsg}
                {dependentResources.map((elem) => (
                  <Text textSize="paragraph" textWeight="500" textColor="shade66" key={elem.id}>
                    {elem.name}
                  </Text>
                ))}
              </>
            ) : (
              deleteMsg
            )}
          </Text>,
          <Div data-test="last-spacer" h="1.875rem" m={{ t: '1.25rem' }} />,
        ],
        buttons,
      }}
    />
  );
}

/* eslint-disable react/require-default-props */
DeleteSegmentDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.func,
        on: PropTypes.func.isRequired,
        after: PropTypes.func,
      })
    ),
  }).isRequired,
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  items: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.element).isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        textSize: PropTypes.string,
        close: PropTypes.bool.isRequired,
      }).isRequired
    ),
  }).isRequired,
  type: PropTypes.string,
  dependentResources: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
/* eslint-enable */

export default DeleteSegmentDialog;
